<template>
  <section id="dashboard-ecommerce">
    <b-row class="match-height">
      <b-col cols="12">
        <ecommerce-statistics />
      </b-col>
    </b-row>

    <b-row v-if="!isAdmin" class="match-height mt-2">
      <b-col v-if="isSale" xl="4" md="6">
        <ecommerce-medal />
      </b-col>

      <b-col v-if="!isSale" xl="4" md="6">
        <ecommerce-medal />
      </b-col>

      <b-col xl="8" md="6" class="mt-2 mt-md-0">
        <!-- :xl="isSale ? 8 : 12" -->
        <ecommerce-revenue-chart />
      </b-col>
    </b-row>

    <!-- <b-row class="match-height mt-2">
      <b-col cols="12">
        <web-chat-stats-chart />
      </b-col>
    </b-row> -->

    <b-row class="match-height mt-2">
      <b-col lg="12" class="d-flex flex-column" style="padding: 0 1.25rem 1rem;">
        <b-card no-body class="flex-fill mb-0 property-requests-card">
          <b-tabs card v-model="tabIndex">
            <b-tab>
              <template #title>
                <span class="d-flex align-items-center" style="gap:6px">
                  Property Requests
                  <b-badge v-if="propertyRequestsTotal > 0" variant="danger" pill>{{ propertyRequestsTotal }}</b-badge>
                </span>
              </template>
              <dashboard-property-requests body-only @update:total="propertyRequestsTotal = $event" />
            </b-tab>

            <b-tab>
              <template #title>
                <span class="d-flex align-items-center" style="gap:6px">
                  Owner Updated Property
                  <b-badge v-if="ownerUpdatesTotal > 0" variant="danger" pill>{{ ownerUpdatesTotal }}</b-badge>
                </span>
              </template>
              <analytics-support-tracker :data="data.supportTracker" body-only @update:total="ownerUpdatesTotal = $event" />
            </b-tab>

            <b-tab>
              <template #title>
                <span class="d-flex align-items-center" style="gap:6px">
                  Leads
                  <b-badge v-if="leadsTotal > 0" variant="danger" pill>{{ leadsTotal }}</b-badge>
                </span>
              </template>
              <leads-list embedded @update:total="leadsTotal = $event" />
            </b-tab>
          </b-tabs>
        </b-card>
      </b-col>
    </b-row>

    <b-row class="match-height mt-2">
      <b-col cols="12">
        <move-out-utility-card />
      </b-col>
    </b-row>
  </section>
</template>

<script>
import {
  BRow, BCol, BCard, BTabs, BTab, BBadge,
} from 'bootstrap-vue'

import { getUserData } from '@/auth/utils'

import EcommerceMedal from './EcommerceMedal.vue'
import EcommerceStatistics from './EcommerceStatistics.vue'
import EcommerceRevenueChart from './EcommerceRevenueChart.vue'
import WebChatStatsChart from './WebChatStatsChart.vue'
import InvoiceList from '@/views/apps/invoice/invoice-list/InvoiceList.vue'
import PropertyList from '@/views/properties/property-list-v2/PropertyList.vue'
import DashboardPropertyRequests from './DashboardPropertyRequests.vue'
import AnalyticsSupportTracker from './AnalyticsSupportTracker.vue'
import LogPropertyUserUpdate from './LogPropertyUserUpdate.vue'
import MoveOutUtilityCard from './MoveOutUtilityCard.vue'
import LeadsList from '@/views/ai-bot/chat-bot/LeadsList.vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BTabs,
    BTab,
    BBadge,
    EcommerceMedal,
    EcommerceStatistics,
    EcommerceRevenueChart,
    WebChatStatsChart,
    InvoiceList,
    PropertyList,
    DashboardPropertyRequests,
    AnalyticsSupportTracker,
    LogPropertyUserUpdate,
    MoveOutUtilityCard,
    LeadsList,
  },
  data() {
    return {
      data: {},
      propertyRequestsTotal: 0,
      ownerUpdatesTotal: 0,
      leadsTotal: 0,
      tabIndex: { 'owner-updates': 1, leads: 2 }[this.$route.query.tab] || 0,
    }
  },
  computed: {
    isSale() {
      const userData = getUserData()
      return userData ? userData.role === 'Sale' : false
    },
    isAdmin() {
      const userData = getUserData()
      return userData ? userData.role === 'Admin' : false
    },
  },
  created() {
    // data
   
    this.$http.get('/ecommerce/data')
      .then(response => {
        this.data = response.data

        // ? Your API will return name of logged in user or you might just directly get name of logged in user
        // ? This is just for demo purpose
        const userData = getUserData()
        this.data.congratulations.name = userData.name
      })
       this.$http.get('/analytics/data')
      .then(response => { this.data.supportTracker = response.data.supportTracker })
       
      
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/dashboard-ecommerce.scss';
@import '@core/scss/vue/libs/chart-apex.scss';

.property-requests-card {
  .card-header {
    padding-bottom: 0.5rem;
  }

  .nav-tabs {
    margin-bottom: 0 !important;
  }

  .tab-content .card-body {
    padding-top: 0.75rem;
  }

  @media (max-width: 575.98px) {
    .nav-tabs {
      flex-wrap: nowrap;
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;
    }

    .nav-tabs .nav-item {
      flex: 0 0 auto;
    }

    .nav-tabs .nav-link {
      white-space: nowrap;
      padding-left: 0.75rem;
      padding-right: 0.75rem;
    }
  }
}
</style>
